<template>
  <div class="fully_verified_page" :style="{ textAlign: $store.state.isMirroring ? 'right' : 'left' }">
    <Tabbar :title="$t('basicLevel.identityVerification')" />
    <div v-if="fromSidebar" class="verify_tabs">
      <div class="verify_tab" @click="goBasic">{{ $t('account.basicTab') }}</div>
      <div class="verify_tab active">{{ $t('account.advancedTab') }}</div>
    </div>
    <div class="page_content">
      <div class="advanced_body">
        <i18n path="fullyVerified.withdrawDailyHint" tag="p" class="daily_hint">
          <span class="daily_amount">$50</span>
        </i18n>
        <div class="upload_list">
          <div class="upload_block">
            <div class="upload_label">
              <img class="required_star" src="@/assets/basicLevel/required_star.svg" alt="" />
              <span>{{ $t('fullyVerified.frontOfId') }}</span>
            </div>
            <van-uploader :after-read="(file) => uploadFile(file, 'front')" :disabled="isLocked">
              <div class="id_card">
                <div class="id_card_face">
                  <img v-if="frontUrl" class="id_preview" :src="frontUrl" alt="" />
                  <template v-else>
                    <img class="id_portrait" src="@/assets/verify/id_front_portrait.png" alt="" />
                    <div class="id_bar bar1"></div>
                    <div class="id_bar bar2"></div>
                    <div class="id_bar bar3"></div>
                  </template>
                </div>
                <div v-if="!frontUrl" class="id_action">
                  <img class="id_camera" src="@/assets/verify/id_camera.svg" alt="" />
                  <div class="id_action_text">{{ $t('fullyVerified.uploadIdFront') }}</div>
                </div>
              </div>
            </van-uploader>
          </div>
          <div class="upload_block">
            <div class="upload_label">
              <img class="required_star" src="@/assets/basicLevel/required_star.svg" alt="" />
              <span>{{ $t('fullyVerified.backOfId') }}</span>
            </div>
            <van-uploader :after-read="(file) => uploadFile(file, 'back')" :disabled="isLocked">
              <div class="id_card">
                <div class="id_card_face back">
                  <img v-if="backUrl" class="id_preview" :src="backUrl" alt="" />
                  <template v-else>
                    <div class="id_bar back1"></div>
                    <div class="id_bar back2"></div>
                    <div class="id_bar back3"></div>
                  </template>
                </div>
                <div v-if="!backUrl" class="id_action">
                  <img class="id_camera" src="@/assets/verify/id_camera.svg" alt="" />
                  <div class="id_action_text">{{ $t('fullyVerified.uploadIdBack') }}</div>
                </div>
              </div>
            </van-uploader>
          </div>
        </div>
      </div>
      <CommonBtn
        v-if="!isLocked"
        class="confirm_btn"
        :disabled="!canSubmit"
        :text="$t('common.submit')"
        :onClick="confirm"
      />
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import CommonBtn from '@/components/CommonBtn'
import { Toast } from 'vant'
import { uploadToAliyunOss } from '../service'
import { postReportLog } from '../utils/log'

export default {
  name: 'FullyVerified',
  components: {
    Tabbar,
    CommonBtn
  },
  data() {
    return {
      frontUrl: '',
      backUrl: ''
    }
  },
  computed: {
    userLevel() {
      return this.$store.state.userInfo.level || 0
    },
    fromSidebar() {
      return this.$route.query.from === 'sidebar'
    },
    isLocked() {
      return this.userLevel >= 2
    },
    canSubmit() {
      return !!(this.frontUrl && this.backUrl)
    }
  },
  created() {
    postReportLog({
      log_id: '440',
      extra: {
        page: 'fully_verified'
      }
    })
    this.getVerifyInfo()
  },
  methods: {
    uploadOssFile: uploadToAliyunOss().uploadFile,
    confirm() {
      if (!this.canSubmit) {
        Toast({
          message: this.$t('fullyVerified.notUploadIdToast')
        })
        return
      }
      this.submitSemi()
    },
    submitSemi() {
      const payload = {
        idCard: this.frontUrl,
        idCardBack: this.backUrl
      }
      return this.$http
        .post(window.serverPath + '/api/user/editInfo/SEMI_VERIFIED', payload)
        .then((res) => {
          if (res.data.code === '200') {
            this.$store.commit('setUserInfo', res.data.data)
            Toast.success({
              message: this.$t('basicLevel.successToast')
            })
            this.$router.replace({ name: 'Withdrawal' })
            return true
          }
          Toast({ message: this.$t('basicLevel.failToast') })
          return false
        })
        .catch((_err) => {
          Toast({ message: this.$t('basicLevel.failToast') })
          return false
        })
    },
    getVerifyInfo() {
      this.$http
        .get(window.serverPath + '/api/user/verifyInfo')
        .then((res) => {
          if (res.data.code === '200' && res.data.data) {
            this.frontUrl = res.data.data.idCard || ''
            this.backUrl = res.data.data.idCardBack || res.data.data.address2 || ''
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    },
    uploadFile(file, type) {
      let toUploadFile
      if (file instanceof Array) {
        toUploadFile = file[0].file
      } else {
        toUploadFile = file.file
      }
      this.uploadOssFile(
        toUploadFile,
        (res) => {
          if (type === 'front') {
            this.frontUrl = res.url
          } else {
            this.backUrl = res.url
          }
        },
        (err) => {
          Toast({
            message: this.$t('fullyVerified.incorrectFormatToast')
          })
          console.error(err)
        }
      )
    },
    goBasic() {
      const name = this.userLevel < 1 ? 'BasicLevel' : 'SemiVerified'
      this.$router.replace({ name, query: { ...this.$route.query } })
    }
  }
}
</script>

<style scoped>
.fully_verified_page {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  scrollbar-width: none;
}

.fully_verified_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.verify_tabs {
  display: flex;
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #efefef;
}

.verify_tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.08rem 0;
  color: #828282;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  border-bottom: 0.02rem solid transparent;
  margin-bottom: -0.01rem;
  box-sizing: border-box;
}

.verify_tab.active {
  color: #3fbb70;
  border-bottom-color: #3fbb70;
}

.page_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0.16rem;
}

.advanced_body {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
  width: 100%;
  padding: 0.12rem 0;
}

.daily_hint {
  width: 100%;
  margin: 0;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.daily_amount {
  color: #3fbb70;
  font-size: 0.18rem;
  font-weight: 600;
  line-height: 0.26rem;
}

.upload_list {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  width: 100%;
}

.upload_block {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.upload_label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.08rem;
  margin-bottom: -0.08rem;
  z-index: 1;
  pointer-events: none;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.2rem;
}

.required_star {
  width: 0.08rem;
  height: 0.08rem;
  flex-shrink: 0;
  display: block;
}

.id_card {
  position: relative;
  width: 100%;
  height: 1.96rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 0.8rem;
  box-sizing: border-box;
}

.id_card_face {
  position: absolute;
  left: 50%;
  top: 0.16rem;
  transform: translateX(-50%);
  width: 2.82rem;
  height: 1.64rem;
  border-radius: 0.16rem;
  background: #f9fdfa;
  border: 0.02rem solid #bfe7cf;
  box-sizing: border-box;
  overflow: hidden;
}

.id_preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.id_portrait {
  position: absolute;
  top: 0.28rem;
  right: 0.24rem;
  width: 0.84rem;
  height: 0.94rem;
  object-fit: contain;
  opacity: 0.4;
}

.id_bar {
  position: absolute;
  left: 0.22rem;
  height: 0.12rem;
  border-radius: 0.03rem;
  background: #bfe7cf;
  opacity: 0.4;
}

.bar1 {
  top: 0.41rem;
  width: 0.96rem;
}

.bar2 {
  top: 0.74rem;
  width: 0.54rem;
}

.bar3 {
  top: 1.08rem;
  width: 0.85rem;
}

.back1 {
  left: 0.34rem;
  top: 0.48rem;
  width: 2.14rem;
}

.back2 {
  left: 0.34rem;
  top: 0.77rem;
  width: 1rem;
}

.back3 {
  left: 0.34rem;
  top: 1.04rem;
  width: 1rem;
}

.id_action {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.11rem;
  width: 100%;
  pointer-events: none;
}

.id_camera {
  width: 0.47rem;
  height: 0.47rem;
  display: block;
  flex-shrink: 0;
}

.id_action_text {
  width: 100%;
  color: #2f2f2f;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.confirm_btn {
  width: 100% !important;
  font-size: 0.16rem !important;
  line-height: 0.24rem;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%) !important;
}

.confirm_btn.disabled {
  background: #c6c6c6 !important;
}
</style>

<style>
.fully_verified_page .van-uploader {
  display: block;
  width: 100%;
}

.fully_verified_page .van-uploader__wrapper,
.fully_verified_page .van-uploader__input-wrapper {
  display: block;
  width: 100%;
}

.fully_verified_page .van-uploader__wrapper--disabled {
  opacity: 1;
}

.fully_verified_page .van-uploader__input {
  z-index: 2;
  font-size: 72px;
  opacity: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/FullyVerified.vue